import React from 'react';
import { Grid } from '@uhg-abyss/web/ui/Grid';
import { styled } from '@uhg-abyss/web/tools/styled';
import {
  Breadcumbs,
  ScreenConstants,
} from '@src/common/BreadCumbs/Breadcrumbs';

export const Details = () => {
  const PaddingBoxContainer = styled('div', {
    paddingTop: '3rem',
    paddingBottom: '2rem',
  });

  return (
    <React.Fragment>
      <div>
        <div style={{ backgroundColor: '#F7FCFD' }} />
        <div
          style={{
            backgroundColor: '#EDF8FA',
            paddingRight: '5rem',
            paddingLeft: '5rem',
          }}
        >
          <PaddingBoxContainer>
            <Grid>
              <Grid.Col span={{ xs: 12, md: 8, lg: 8 }}>
                <div>
                  <Breadcumbs screen={ScreenConstants.BENEFIT_DETAILS} />
                </div>
              </Grid.Col>
            </Grid>
          </PaddingBoxContainer>
        </div>
      </div>
    </React.Fragment>
  );
};
